import { initializeApp } from "firebase/app";
import { getMessaging, getToken, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export const app = initializeApp(firebaseConfig);

export const getMessagingInstance = async () => {
  try {
    const supported = await isSupported();
    if (supported) {
      return getMessaging(app);
    }
  } catch (err) {
    console.warn("Firebase Messaging is not supported in this environment:", err);
  }
  return null;
};

let tokenRequest;

export const getOrCreateFcmToken = async () => {
  if (tokenRequest) return tokenRequest;

  tokenRequest = (async () => {
    if (
      typeof window === "undefined" ||
      !("Notification" in window) ||
      !("serviceWorker" in navigator)
    ) {
      return null;
    }

    const messaging = await getMessagingInstance();
    if (!messaging) return null;

    const permission =
      Notification.permission === "granted"
        ? "granted"
        : await Notification.requestPermission();
    if (permission !== "granted") return null;

    const registration = await navigator.serviceWorker.register(
      "/firebase-messaging-sw.js"
    );
    const options = { serviceWorkerRegistration: registration };
    if (import.meta.env.VITE_APP_VAPID_KEY) {
      options.vapidKey = import.meta.env.VITE_APP_VAPID_KEY;
    }

    const token = await getToken(messaging, options);
    if (token) localStorage.setItem("fcm", token);
    return token || null;
  })().finally(() => {
    tokenRequest = null;
  });

  return tokenRequest;
};
